export const SuccessRoundedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fill="#34C759"
      d="M8.938 0a8.937 8.937 0 1 0 8.937 8.938A8.947 8.947 0 0 0 8.937 0Zm3.923 7.361L8.05 12.174a.688.688 0 0 1-.973 0L5.014 10.11a.688.688 0 1 1 .972-.972l1.577 1.577 4.326-4.327a.688.688 0 0 1 .972.972Z"
    />
  </svg>
);
